// Vendor-is-a-company helpers for the Authority form (Genneva Smarrelli, DOMA
// 13234735418 / CRM-2026-00104). When the vendor is a company, the company name
// + ABN + director/signatory replace the individual "Vendor name"; otherwise the
// company fields are hidden and the vendor tab looks exactly as before.

export const VENDOR_COMPANY_FIELDS = [
  "vendor_company_name",
  "vendor_abn",
  "vendor_signatory_name",
  "vendor_signatory_capacity",
];

export const isCompanyVendor = (values) =>
  (values?.vendor_entity || "individual") === "company";

// Keys to hide in the Vendor section for the entity toggle. vendor_entity itself
// is always hidden here because it renders on its own above the question grid.
export function companyVendorHiddenKeys(values) {
  const hidden = new Set(["vendor_entity"]);
  if (isCompanyVendor(values)) {
    hidden.add("vendor_name");
  } else {
    VENDOR_COMPANY_FIELDS.forEach((k) => hidden.add(k));
  }
  return hidden;
}

// When Company, float the company fields to the front so the tab reads
// company name -> ABN -> director -> capacity, then the rest. Stable otherwise.
export function orderVendorQuestions(questions, values) {
  if (!isCompanyVendor(values)) return questions;
  return [...questions].sort((a, b) => {
    const ai = VENDOR_COMPANY_FIELDS.indexOf(a.key);
    const bi = VENDOR_COMPANY_FIELDS.indexOf(b.key);
    return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi);
  });
}
